import api from "./ApiService";

const authenticate = async (username, password) => {
  const res = await api.post("User/Auth", {
    username,
    password,
  });
  return res.data;
};

const UserService = {
  authenticate,
};

export default UserService;
